import { startCatalogueSearch } from './shared/utils/catalogueStartup';

window.bundleSearchStartup = startCatalogueSearch(window.bundleSearchModel);
